import { useEffect, useRef } from 'react';

export const useOutOfStockPageLoadEvent = (track) => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (track && !hasTracked.current) {
      hasTracked.current = true;
      window.LIFE_CYCLE_EVENT_BUS.trigger('swap-item.oos-recommendations-page-load', { inStockApp: 'false' });
    }
  }, [track]);
};
